import { Patient } from 'src/interfaces';

export enum PATIENT_STATUSES {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DECEASED = 'deceased'
}

export enum GENDER {
  MALE = 'male',
  FEMALE = 'female'
}

export const dummyPatient: Patient = {
  sourceId: 0,
  patientId: '',
  practiceId: 0,
  name: 'Rover',
  diet: '',
  displayId: null,
  birthdate: null,
  deceasedDate: null,
  insuranceProvider: '',
  status: '',
  species: 'dog',
  breed: '',
  sex: '',
  photoUrl: '',
  photo: {
    urls: {
      small: '',
      original: '',
      large: ''
    }
  },
  policyNumber: '',
  hasPhoto: false,
  weight: '',
  weightUnit: '',
  medicalConditions: '',
  rabiesTag: '',
  microchipNumber: ''
};
